var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobilePlayInverted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 15,
  viewBox: "0 0 12 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.5.147a1.5 1.5 0 0 1 .784.22l9.034 5.538a1.5 1.5 0 0 1 0 2.558l-9.034 5.538A1.5 1.5 0 0 1 0 12.72V1.648a1.5 1.5 0 0 1 1.5-1.5m.047 1.568v10.941l8.892-5.472z"
})));
export default SvgInstagramMobilePlayInverted;